import { useLanguage } from "@/i18n";
import { Reveal, SectionHeader } from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FaqSection = () => {
  const { t } = useLanguage();

  return (
    <section id="faq" className="py-24 sm:py-32 bg-obsidian" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-5 gap-12">
          <div className="lg:col-span-2">
            <SectionHeader eyebrow={t.faq.eyebrow} title={t.faq.title} />
          </div>
          <Reveal className="lg:col-span-3" delay={0.15}>
            <Accordion type="single" collapsible className="w-full">
              {t.faq.items.map((item, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border-hairline">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left font-serif text-lg sm:text-xl text-ivory hover:text-gold hover:no-underline transition-colors py-6"
                  >
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm sm:text-base leading-relaxed text-slate-400 pb-6">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
